<template>
  <Dropdown
    ref="dropdown"
    tag="span"
    :menu-right="true"
    class="bulk-actions-dropdown pull-right column-toggle"
    :not-close-elements="ele"
  >
    <button>
      <span class="typcn typcn-cog" />
    </button>

    <template slot="dropdown">
      <li
        v-for="setting in tempColumnSettings"
        :key="setting.displayName"
        class=""
      >
        <div class="menu-item">
          <input
            :id="setting.name"
            type="checkbox"
            :name="setting.name"
            :checked="!setting.hide"
            class="m-r-4"
            @change="saveColumnVisibility(setting)"
          >
          <label
            :for="setting.name"
            v-text="$t(setting.displayName)"
          />
        </div>
      </li>
    </template>
  </Dropdown>
</template>

<script>
import messages from './locales';
import { columnsFetchService, userSettingsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { STATUS_SUCCESS, STATUS_PENDING } from '@/store/helpers';
import sharedMessages from '@/core/locales';

export default {
  name: 'ColumnToggle',
  props: {
    tableName: {
      type: String,
      default: ''
    },
    userSettings: {
      type: Object,
      default: function() {
        return {};
      }
    },
    settingsStatus: {
      type: Object,
      default: function() {
        return {
          status: STATUS_PENDING
        };
      }
    },
    columnSettings: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      ele: []
    };
  },
  computed: {
    tempColumnSettings() {
      if(this.settingsStatus.status == STATUS_SUCCESS) {
        const tempColumnSettings = this._getTempColumnSettings();
        this.$emit('onChange');
        return tempColumnSettings;
      }
      return [];
    }
  },
  mounted() {
    this.ele.push(this.$refs.dropdown.$el);
  },
  methods: {
    saveColumnVisibility (columnSetting){
      columnSetting.hide = !columnSetting.hide;
      this.columnSettings[columnSetting['name']].hide = columnSetting.hide;
      var newSettings = {
        hide: columnSetting.hide
      };
      if (!this.userSettings) {
        userSettingsService.getUserSettings()
          .then((userSettings) => {
            this.userSettings = userSettings;
            this._saveColumnSettings(this.userSettings, columnSetting['name'], newSettings);
          });
      } else {
        this._saveColumnSettings(this.userSettings, columnSetting['name'], newSettings);
      }
      this.$emit('onChange');
    },
    _saveColumnSettings(userSettings, name, settings) {
      if (!userSettings[this.tableName]) {
        userSettings[this.tableName] = {};
      }
      userSettings[this.tableName].columnSettings = userSettings[this.tableName].columnSettings || {};
      userSettings[this.tableName].columnSettings[name] = settings;
      return userSettingsService.saveUserSettings(userSettings);
    },
    _columnSettingsChanged() {
      this.tempColumnSettings = this._getTempColumnSettings();
    },
    _getTempColumnSettings() {
      let tempColumnSettings = _.cloneDeep(this.columnSettings);
      var copyColumnSettings = _.cloneDeep(this.columnSettings);

      tempColumnSettings = _.reduce(tempColumnSettings, (result, value, key) => {
        if (copyColumnSettings[key]) {
          if (copyColumnSettings[key]['hideForUserType'] && columnsFetchService.hideForUser(copyColumnSettings[key]['hideForUserType'])) {
            return result;
          }

          const tableSettings = this.userSettings[this.tableName];
          let userSettings;
          if(tableSettings && tableSettings.columnSettings) {
            userSettings = tableSettings.columnSettings[key];
          }
          value['hide'] = userSettings ? userSettings.hide : false;
          value['name'] = key;
          this.columnSettings[key].hide = value['hide'];
          result.push(value);
        } else {
          delete this.columnSettings[key];
        }
        return result;
      }, []);

      tempColumnSettings = _.sortBy(tempColumnSettings, (o) => {
        return this.$t(o.displayName) || o.displayName;
      });

      return tempColumnSettings;
    }

  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .column-toggle button {
    background-color: transparent;
    border: 0;
  }

  .column-toggle li {
    font-size: 12px;
    color:white;
    padding: 2px 10px;

    label {
      line-height: 26px;
      font-weight: 400;
      margin-bottom: 0;
      cursor: pointer;
    }
  }
</style>
